export default __webpack_public_path__ + "static/media/PÁGINA SLIDE - SOMIT INGLÉS .781a6b55.jpg";